import { Outlet, useParams } from "react-router";

export function TradesHandler(props){
    
    let param = useParams();
    return <Outlet {...props} params={param} />
}